import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getBlogs, removeBlog, updateBlog } from 'slice/blogSlice';
import AdminTable from 'common/AdminTable';
import TruncatedMessage from 'common/TruncatedMessage';

const ListBlog = () => {
  const dispatch = useDispatch();
  const { data: blogData } = useSelector((state) => state.blog);

  const [showModal, setShowModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [currentBlog, setCurrentBlog] = useState(null);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    dispatch(getBlogs());
  }, [dispatch]);

  const handleEditClick = (blog) => {
    setCurrentBlog(blog);
    setImageFile(null);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentBlog(null);
    setImageFile(null);
  };
const handleSave = async () => {
  const formData = new FormData();
  for (const key in currentBlog) {
    if (key !== 'image') formData.append(key, currentBlog[key]);
  }
  if (imageFile) {
    formData.append('image', imageFile);
  }

  try {
    await dispatch(updateBlog({ id: currentBlog.id, data: formData })).unwrap();
    handleCloseModal();
  } catch (error) {
    console.error("Update failed", error);
  }
};


  const handleImageChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const tableHeaders = [
    {
      Header: 'Image',
      accessor: 'image',
      Cell: ({ row }) => (
        <img
          src={`${process.env.REACT_APP_BACKEND}uploads/blogs/${row.original.image}`}
          alt={row.original.title}
          width={50}
        />
      ),
    },
    { Header: 'Title', accessor: 'title' },
    {
      Header: 'Description',
      accessor: 'description',
      Cell: ({ row }) => (
        <TruncatedMessage text={row.original.description} maxLength={30} />
      ),
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button
            className="btn btn-info mx-1"
            onClick={() => {
              setSelectedBlog(row.original);
              setViewModal(true);
            }}
          >
            View
          </button>
          <button
            className="btn removebtn mx-1"
            onClick={() => {
              if (window.confirm('Are you sure you want to remove this blog?')) {
                dispatch(removeBlog(row.original.id));
              }
            }}
          >
            Remove
          </button>
          <button
            className="btn editbtn mx-1"
            onClick={() => handleEditClick(row.original)}
          >
            Edit
          </button>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="container-fluid mt-5">
        <div className="mainheadig mx-4">
          <h4 className="text-white font-weight-bold">Blog List</h4>
        </div>

        {blogData?.length > 0 && (
          <AdminTable tableHeaders={tableHeaders} tableData={blogData} />
        )}
      </div>

      {/* Edit Modal */}
      {showModal && currentBlog && (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Blog</h5>
                <button type="button" className="close" onClick={handleCloseModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                <form>
                  <div className="form-group">
                    <label htmlFor="title">Title</label>
                    <input
                      id="title"
                      name="title"
                      type="text"
                      className="form-control"
                      value={currentBlog.title || ''}
                      onChange={(e) => setCurrentBlog({ ...currentBlog, title: e.target.value })}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="description">Description</label>
                    <textarea
                      id="description"
                      name="description"
                      className="form-control"
                      rows={5}
                      value={currentBlog.description || ''}
                      onChange={(e) => setCurrentBlog({ ...currentBlog, description: e.target.value })}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="image">Image</label>
                    <input id="image" type="file" className="form-control" onChange={handleImageChange} />
                    {currentBlog.image && (
                      <img
                        src={`${process.env.REACT_APP_BACKEND}uploads/${currentBlog.image}`}
                        alt={currentBlog.title}
                        width={80}
                        className="mt-2"
                      />
                    )}
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={handleCloseModal}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleSave}>
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* View Modal */}
      {viewModal && selectedBlog && (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div className="modal-content border-0 shadow-lg rounded">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">Blog Details</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setViewModal(false)}></button>
              </div>
              <div className="modal-body py-4 px-4" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                <div className="row gy-3">
                  {[{ label: 'Title', value: selectedBlog.title }, { label: 'Description', value: selectedBlog.description }].map(
                    ({ label, value }, idx) => (
                      <div className="col-md-6" key={idx}>
                        <label className="fw-bold text-dark d-block mb-1">{label}</label>
                        <div className="text-secondary fs-6">{value}</div>
                      </div>
                    )
                  )}
                  {selectedBlog.image && (
                    <div className="col-md-12 text-center mt-3">
                      <img
                        src={`${process.env.REACT_APP_BACKEND}uploads/${selectedBlog.image}`}
                        alt={selectedBlog.title}
                        width={150}
                        className="rounded"
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={() => setViewModal(false)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ListBlog;
